

// components/VisitSaleChart.js
import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js'; // Import the 'auto' version for Chart.js
import axios from "axios";
import { BASE_URL } from "../../App";

export const VisitSaleChart = () => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null); // Add a ref for the chart instance

  const login_id = localStorage.getItem("LOGIN_ID");
  const user_id = localStorage.getItem("USER_ID");

  const [dashboardChart, setDashboardChart] = useState([]);

  const dashboardView = async () => {
    try {
      const formData = new FormData();
      formData.append("login_id", login_id);

      const response = await axios.post(BASE_URL + "/dashboardView", formData);
      
      // Map the response data to the format needed
      const chartData = response.data.chart.map(item => ({
        month: item.Month,
        totalNetValue: parseFloat(item.TotalNetValue) || 0 // Convert to number, default to 0 if NaN
      }));

      setDashboardChart(chartData);
  
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([dashboardView()]);
      } catch (error) {
        console.error('Error during data fetching:', error);
      }
    };
  
    fetchData();
  }, []);

  useEffect(() => {
    if (chartRef.current && dashboardChart.length > 0) {
      const ctx = chartRef.current.getContext('2d');

      // Clean up the old chart instance if it exists
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }

      const graphGradient2 = ctx.createLinearGradient(0, 0, 0, 360);
      graphGradient2.addColorStop(0, 'rgba(54, 215, 232, 1)');
      graphGradient2.addColorStop(1, 'rgba(177, 148, 250, 1)');

      // Create a new chart instance
      chartInstanceRef.current = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dashboardChart.map(item => item.month || 0), // Use mapped month
          datasets: [
            {
              label: "Current Year",
              borderColor: graphGradient2,
              backgroundColor: graphGradient2,
              data: dashboardChart.map(item => item.totalNetValue|| 0), // Use mapped totalNetValue
              barPercentage: 0.5,
              categoryPercentage: 0.5,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            y: {
              display: true, // Set to true to display y-axis
              grid: {
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
              },
            },
            x: {
              display: true,
              grid: {
                display: false,
              },
            },
          },
          plugins: {
            legend: {
              display: true, // Set to true to display legend
            },
          },
        },
      });
    }
  }, [dashboardChart]); // Update the chart when dashboardChart changes

  return <canvas id="visit-sale-chart" ref={chartRef}></canvas>;
};
